import { CLIENTE } from "@pcgerente-node/pcg-comun/dist/DTOs";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getInfoDestinatario } from "../../../../redux/actions/actionsCrear";
import { RootState, useAppDispatch } from "../../../../redux/store";
import "../../../../styles/formulariodestinatario.css";
import { HayDobleTap } from "../../../../Utils/funciones";
import { obtenerTipoIdentificacion } from "../../../../Utils/obtenerTipoIdentificacion";
import { numerosNaturales } from "../../../../Utils/regex";
import BusquedaCliente from "../../../Consulta/Ventanas_Auxiliares/BusquedaCliente";
import { logistica_GUIA_PROFORMALocal } from "../../../Entidades/logistica_GUIA_PROFORMA";
import { ChildProps_logistica_GUIA_PROFORMAviewModel } from "../ContentGuia";
import ModalAgencia from "./ModalAgencia";
import { StyleProps1, StyleProps2, StyleProps3 } from "./Styles";

const FormularioDestinatario: React.FC<ChildProps_logistica_GUIA_PROFORMAviewModel> = ({vm, guia, setGuia}) => {

  const infoEstadoDestinatarioStore = useSelector((state: RootState) => state.crear.destinatario)
  const destinatarioStore = infoEstadoDestinatarioStore.info
  const [crearDestinatario, setCrearDestinatario] = useState(false)
  const [MostrarBusquedaCliente, setMostrarBusquedaCliente] = useState(false)
  const dispatch = useAppDispatch()


  useEffect(() => {
  if( destinatarioStore && guia.idDestinatario !== destinatarioStore.id){
        vm.EstablecerClienteDestinatario(destinatarioStore,guia,setGuia)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [destinatarioStore,dispatch]);

  return (
    <div className="col-xl-6 invoice-address-client">
      <h4 style={StyleProps3}>Destinatario:</h4>
      <div className="invoice-address-client-fields">
        <div className="form-group row">
          <label
            htmlFor="name"
            className="col-sm-2 col-form-label"
          >
            Nombre:
          </label>
          <div className="col-sm-10">
            <input
              type="text"
              readOnly= {!crearDestinatario}
              className="form-control-plaintext"
              style={StyleProps1}
              value={guia.CLIENTE_DESTINATARIO?.razonSocial||""} 
              placeholder = "Ingrese una Razón Social"
              onChange={(e) => handleInfo(e, "razonSocial")}
            />
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="name"
            className="col-sm-2 col-form-label"
          >
            Cédula:
          </label>
          <div className="col-sm-10">
            <input
              type="id"
              className="form-control-plaintext"
              style= {StyleProps1}
              value={guia.CLIENTE_DESTINATARIO?.cedula|| ""}
              placeholder="Haz doble click para empezar la busqueda"
              onKeyDown={(e) => handleBusquedaCliente(e)} //Teclado
              onDoubleClick={() => setMostrarBusquedaCliente(true)} //PC
              onTouchStart={() => HayDobleTap()? setMostrarBusquedaCliente(true):null} //Móvil
              onChange={(e) => handleInfo(e, "cedula")}
            />
          </div>
        </div>

        <div className="form-group row">
          <label
            htmlFor="name"
            className="col-sm-2 col-form-label"
          >
            Dirección:
          </label>
          { }
          <div className="col-sm-10">
            <input
              type="adress"
              readOnly= {!crearDestinatario}
              className="form-control-plaintext"
              style= {StyleProps1}
              value={guia.CLIENTE_DESTINATARIO?.direccion || ""}
              placeholder="Ingrese una dirección"
              onChange={(e) => handleInfo(e, "direccion")}
            />
          </div>
        </div>

        <div className="form-group row">
          <label
            htmlFor="name"
            className="col-sm-2 col-form-label"
          >
            Teléfono:
          </label>
          <div className="col-sm-10">
            <input
              type="phone"
              readOnly= {!crearDestinatario}
              className="form-control-plaintext"
              style= {StyleProps1}
              value={guia.CLIENTE_DESTINATARIO?.telefono||""}
              placeholder ={"Ingrese un teléfono"}
              onChange={(e) => handleInfo(e, "telefono")}
            />
          </div>
        </div>

        <div className="form-group row">
          <label
            htmlFor="name"
            className="col-sm-2 col-form-label"
          >
            Email:
          </label>
          <div className="col-sm-10">
            <input
              type="email"
              readOnly= {!crearDestinatario}
              className="form-control-plaintext"
              style= {StyleProps1}
              value={guia.CLIENTE_DESTINATARIO?.email|| ""}
              placeholder="Ingrese un email"
              onChange={(e) => handleInfo(e, "email")}
            />
          </div>
        </div>

        <div className="form-group row">
          <label
            htmlFor="name"
            className="col-sm-2 col-form-label"
          >
            Agencia:
          </label>
            
          {guia.CLIENTE_DESTINATARIO?.CLIENTE_DIRECCION_PROFORMA?.length?
          <div className="agencia-input-destinatario">
                <button 
                  onClick={() => quitarEstablecimiento(setGuia,guia)} 
                  className="btn btn-danger"
                  disabled ={guia.direccionDestinatario.length ===0}
                >
                  Limpiar
                </button>
                <ModalAgencia vm={vm} guia={guia} setGuia={setGuia}/>
                <span>{guia.direccionDestinatario}</span>
          </div>
          :<div className="col-sm-10">
            <input
              type="text"
              className="form-control-plaintext"
              style= {StyleProps1}
              readOnly= {!crearDestinatario}
              value={guia?.direccionDestinatario ||""}
              onChange={(e) => handleInfo(e, "direccionDestinatario")}
              placeholder= "Ingrese un establecimiento"
            />
          </div>
          }
        </div>
      </div>
      <div className="d-flex align-items-center">
          <input
           type="checkbox" 
           className="d-flex me-5 "
           checked={crearDestinatario}
           onChange={(e) => vm.CrearDestinatario(setCrearDestinatario, e.target.checked , guia, setGuia)}
          />
          <label htmlFor="name" style={StyleProps2} className="d-flex mb-0 ms-4 ">
            Crear Nuevo Destinatario:
          </label>
        </div>
      <BusquedaCliente 
        mostrar={MostrarBusquedaCliente}
        setMostrar={setMostrarBusquedaCliente}
        setCliente={BuscarDestinatarioPorCedula}
        query={guia.CLIENTE_DESTINATARIO?.cedula??""}
        campoBusqueda="cedula"
      />
    </div>
  );


  function handleInfo (e: ChangeEvent<HTMLInputElement>, type: "cedula"|"razonSocial"|"telefono"|"direccion"|"email"|"direccionDestinatario") {
    //Inicializamos el Cliente Destinatario por si no existe
    if(guia.CLIENTE_DESTINATARIO === undefined){
      guia.CLIENTE_DESTINATARIO = new CLIENTE
    }
    let data = e.target.value
    if(type === "cedula" && data.length<=13 ){
      setGuia({...
        guia,
        CLIENTE_DESTINATARIO:{
          ...guia.CLIENTE_DESTINATARIO,
          cedula: data,   
          idTipoIdentificacion: obtenerTipoIdentificacion(data)
        }
      })
    }

    if(type === "email" && guia.CLIENTE_DESTINATARIO && data.length<50){
      setGuia({...
        guia,
        CLIENTE_DESTINATARIO:{...guia.CLIENTE_DESTINATARIO,
          email: data      
        }
      })
    }

    if((type === "direccion" || type === "direccionDestinatario") && guia.CLIENTE_DESTINATARIO && data.length<100){
      guia.CLIENTE_DESTINATARIO.direccion = data    
      setGuia({...
        guia,
        CLIENTE_DESTINATARIO:{
          ...guia.CLIENTE_DESTINATARIO,
          direccion: data      
        },
        direccionDestinatario: data
      })  

    }
    if(type === "telefono" && guia.CLIENTE_DESTINATARIO && (numerosNaturales(data)|| !data) && data.length <50){
      setGuia({...
        guia,
        CLIENTE_DESTINATARIO:{
          ...guia.CLIENTE_DESTINATARIO,
          telefono: data      
        }
      })
    }

    if(type === "razonSocial" && guia.CLIENTE_DESTINATARIO && data.length<300){
      setGuia({...
        guia,
        CLIENTE_DESTINATARIO:{
          ...guia.CLIENTE_DESTINATARIO,
          razonSocial: data
        }
      })
    }

    vm.NotifyPropertyChanged()
  }



  function quitarEstablecimiento(setState: (details: logistica_GUIA_PROFORMALocal) => void, guia:logistica_GUIA_PROFORMALocal ) {
    if((destinatarioStore as any)?.idCiudad && guia.CLIENTE_DESTINATARIO ){
      setState({...guia,
        CLIENTE_DESTINATARIO: {...guia.CLIENTE_DESTINATARIO, 
          ciudad: destinatarioStore.ciudad
        },
        direccionDestinatario: guia.CLIENTE_DESTINATARIO.direccion
      })
    }
  }

  async function handleBusquedaCliente(e? : React.KeyboardEvent<HTMLInputElement>){
    if(e?.key === "Enter" ){
      const cedula = guia.CLIENTE_DESTINATARIO?.cedula ?? ""
      BuscarDestinatarioPorCedula(cedula)
    }
  }

  async function BuscarDestinatarioPorCedula(cedula:string){
    await dispatch(getInfoDestinatario(cedula))
  };

};

export default FormularioDestinatario;
